<div class="session-dashboard-wrapper" style="padding:0 50px">
    <celebrate></celebrate>
    <div class="header-container">
        <div class="select-container shop-session-title">
            Shop Session Dashboard
        </div>
        <div class="tabs">
            <div class="tab"
                 (click)="setActiveTab(0)"
                 [class.active]="activeTab === 0">
                Realtime
            </div>
            <div class="tab"
                 (click)="setActiveTab(1)"
                 [class.active]="activeTab === 1">
                Share Links
            </div>
            <div class="tab"
                 (click)="setActiveTab(2)"
                 [class.active]="activeTab === 2">
                All Sessions
            </div>
        </div>
    </div>

    <div *ngIf="activeTab === 0">
        <ssd-tab-realtime ></ssd-tab-realtime>
    </div>

    <div *ngIf="activeTab === 1">
        <ssd-tab-share ></ssd-tab-share>
    </div>

    <div *ngIf="activeTab === 2">
        <ssd-tab-summary ></ssd-tab-summary>
    </div>


</div>
